// SVG text has no layout box, and getBBox() is unavailable at render time (and in jsdom), so label
// widths are estimated. Measured in-browser, the panel's font renders at 5.3-6.9px/char at fontSize
// 11; 0.6 * fontSize (6.6px at 11, 6.0px at 10) sits above that average so the estimate errs toward
// cutting a character early rather than letting a wide name spill out of its slot.
export const CHAR_W_RATIO = 0.6;

export const ELLIPSIS = '…';

export interface FittedLabel {
    text: string;
    truncated: boolean;
}

export function charWidth(fontSize: number): number {
    return fontSize * CHAR_W_RATIO;
}

export function labelWidth(text: string, fontSize: number): number {
    return text.length * charWidth(fontSize);
}

// Fits `text` into `budgetPx` of horizontal room, cutting with an ellipsis when it does not fit.
export function fitLabel(text: string, budgetPx: number, fontSize: number): FittedLabel {
    const maxChars = Math.floor(budgetPx / charWidth(fontSize));
    if (maxChars >= text.length) return { text, truncated: false };
    if (maxChars < 1) return { text: '', truncated: text.length > 0 };
    if (maxChars === 1) return { text: ELLIPSIS, truncated: true };
    return { text: text.slice(0, maxChars - 1).trimEnd() + ELLIPSIS, truncated: true };
}
